import EFButton from '@/efelement/EFButton';
import { useGlobal } from '@/utils/useGlobal';
import EfLink from '@elem/ui/ef-link';
import css from './index.module.scss';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

export default function ProductNav({
    title,
    className,
    theme = 'white',
    buyLink,
    callback,
    hasDetail = true,
    productKey,
    showQuote = false,
    callbackQuote,
    showBlog,
    children,
    langKey = '',
    buyText,
}: any) {
    const { useState, useEffect, isMobile, useLang, gtm, useRouter } = useGlobal();
    const { locale, pathname } = useRouter();
    const [isShowNav, setIsShowNav] = useState(false);
    const [idx, setIdx] = useState('Overview');
    const { t } = useLang('shared');
    if (!theme) theme = 'white';

    let tabMap: any = {
        Overview: langKey === 'solarspeicher' ? 'Solarspeicher' : t('product.nav_overview'),
        Specs: langKey === 'solarspeicher' ? 'PowerOcean Serie' : t('product.nav_specs'),
        Support: langKey === 'solarspeicher' ? 'FAQs' : t('product.nav_support'),
    };

    if (pathname === '/home-battery/PowerOcean') {
        tabMap = {
            Overiew: langKey === 'solarspeicher' ? 'Solarspeicher' : t('product.nav_overview'),
            Support: langKey === 'solarspeicher' ? 'FAQs' : t('product.nav_support'),
        };
    }

    const tabChange = (name: string) => {
        if (langKey === 'solarspeicher') {
            setIdx(name);
            callback(name);
            if (name === 'Overview') {
                const target = document.querySelector('.power-ocean-collection-A') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 80,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            if (name === 'Specs') {
                const target = document.querySelector('.power-ocean-collection-D') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 80,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            if (name === 'Support') {
                const target = document.querySelector('.power-ocean-collection-L') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 80,
                        behavior: 'smooth',
                    });
                }
                return;
            }
        }
        if (typeof document !== 'undefined') {
            window.scrollTo(0, 0);
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: name === 'Faq' ? 'FAQ' : name,
            product_name: title,
        });
        setIdx(name);
        callback(name);
    };

    const mTabChange = (name: string) => {
        if (langKey === 'solarspeicher') {
            setIdx(name);
            callback(name);
            setIsShowNav(false);
            if (name === 'Overview') {
                const target = document.querySelector('.power-ocean-collection-A') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 60,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            if (name === 'Specs') {
                const target = document.querySelector('.power-ocean-collection-D') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 60,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            if (name === 'Support') {
                const target = document.querySelector('.power-ocean-collection-L') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 60,
                        behavior: 'smooth',
                    });
                }
                return;
            }
        }
        if (typeof document !== 'undefined') {
            window.scrollTo(0, 0);
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: name === 'Faq' ? 'FAQ' : name,
            product_name: title,
        });
        setIdx(name);
        callback(name);
        setIsShowNav(false);
    };

    const handleClickOtherDom = (e: MouseEvent) => {
        const shouleHideEle = document.querySelector('.detail-nav');
        const clickEle = e.target as Element;
        if (!shouleHideEle?.contains(clickEle)) {
            setIsShowNav(false);
        }
    };

    // river2 产品详情页导航栏buy按钮特殊处理
    const onRiver2Buy = () => {
        const river2_D = document.querySelector('.river2_details_D') as HTMLElement;
        const header = document.querySelector('.product_naver') as HTMLElement;
        window.scrollTo({
            top: (isMobile ? river2_D?.offsetTop : river2_D?.offsetTop + 300) - header?.offsetHeight,
            behavior: 'smooth',
        });
    };

    const renderFrostNav = () => {
        let initScrollTop = 0;
        const regionPopupEl = document.querySelector('.regionPopup') as HTMLElement;
        if (regionPopupEl) {
            initScrollTop += regionPopupEl?.offsetHeight;
        }
        const headerEl = document.querySelector('.ecoflow-frame-header') as HTMLElement;
        if (headerEl) {
            initScrollTop += headerEl?.offsetHeight;
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const productNav = document.querySelectorAll('section.wbg')[0];
        productNav?.classList.toggle('frost', scrollTop > initScrollTop);
    };

    const handleBuyLinkClick = (link: string) => {
        saveAICookieForShopify(link, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: title,
            position: 'Product Details Navigation',
        });
    };
    useEffect(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
            document.querySelectorAll('section.wbg')[0]?.classList.add('frost');
        }
        if (!hasDetail) {
            setIdx('Specs');
        }
        /* @ts-ignore */
        document.addEventListener('touchstart', handleClickOtherDom);
        // 毛玻璃效果
        document.addEventListener('scroll', renderFrostNav);
        return () => {
            /* @ts-ignore */
            document.removeEventListener('touchstart', handleClickOtherDom);
            document.removeEventListener('scroll', renderFrostNav);
            const product_naver = document.querySelector('section.product_naver');
            product_naver?.classList.remove('hideBuy');
        };
    }, []);

    const [top, setTop] = useState(0);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const header = document.querySelector('.ecoflow-frame-header') as HTMLDivElement;
                const bar = document.querySelector('.announcement-bar ') as HTMLElement;
                if (header && bar) {
                    const computedHeaderStyle = window.getComputedStyle(header);
                    const positionHeaderValue = computedHeaderStyle.getPropertyValue('position');
                    const computedBarStyle = window.getComputedStyle(bar);
                    const positionBarValue = computedBarStyle.getPropertyValue('position');
                    if (positionHeaderValue === 'sticky') {
                        setTop(header?.offsetHeight + (positionBarValue === 'sticky' ? bar?.offsetHeight : 0));
                    }
                    if (positionHeaderValue === 'relative') {
                        setTop(0 + (positionBarValue === 'sticky' ? bar?.offsetHeight : 0));
                    }
                }
            }, 3500);
        }
    }, []);

    const IS_POWERSTREAM_COOPERATION = pathname === '/powerstream-cooperation';

    return (
        <section
            className={`${css.naver} product_naver naver ${className} cover ${theme} ${isMobile ? 'product_naver_h5' : 'product_naver_pc'}`}
            style={{ top: `${top}px`, '--theme': theme, '--theme-bg': theme === 'black' ? 'white' : 'black' } as React.CSSProperties}
        >
            <div className="container">
                <div className={`detail-nav ${theme}`}>
                    <h1 className={`left ${IS_POWERSTREAM_COOPERATION ? 'short' : ''}`} title={title}>
                        {title}
                    </h1>
                    <div className="right">
                        <div
                            className={`tab-dropdown${
                                (t('product.buy') && buyLink) || (productKey === 'product_ps_river_river_256' && !buyLink && locale !== 'tw') ? '' : ' empty'
                            }`}
                            onClick={() => setIsShowNav(!isShowNav)}
                        >
                            <span className="tab-dropdown-name">{tabMap[idx] || tabMap[0]}</span>
                            <span className={`tab-dropdown-icon${isShowNav ? ' active' : ''}`}></span>
                        </div>
                        <ul
                            className={`rightLists${
                                (t('product.buy') && buyLink) || (productKey === 'product_ps_river_river_256' && !buyLink && locale !== 'tw') ? '' : ' empty'
                            }`}
                        >
                            {hasDetail && (
                                <li className={`list-menu${idx === 'Overview' ? ` active black` : ''}`} onClick={() => tabChange('Overview')}>
                                    <span> {langKey === 'solarspeicher' ? 'Solarspeicher' : t('product.nav_overview')}</span>
                                </li>
                            )}
                            {pathname === '/home-battery/PowerOcean' && title === 'PowerOcean' && (
                                <li className="list-menu blog-link">
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`https://www.ecoflow.com/${locale}/solutions/home-battery/PowerOcean/EcoFlow-App`}
                                    >
                                        {t('product.nav_app')}
                                    </a>
                                </li>
                            )}
                            {pathname !== '/home-battery/PowerOcean' && (
                                <li
                                    onClick={() => tabChange('Specs')}
                                    className={`list-menu${idx == 'Specs' || (idx == 'Specs' && !hasDetail) ? ` active ${theme}` : ''}`}
                                >
                                    <span> {langKey === 'solarspeicher' ? 'PowerOcean Serie' : t('product.nav_specs')}</span>
                                </li>
                            )}
                            {showBlog && pathname !== '/home-battery/PowerOcean' && (
                                <li className="list-menu blog-link">
                                    <EfLink
                                        href="https://blog.ecoflow.com/de/category/heimspeicher/"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'product_navigation',
                                            navigation_name: 'Solar 101 (blog+user story)',
                                            product_name: title,
                                        }}
                                    >
                                        {t('product.nav_blog')}
                                    </EfLink>
                                </li>
                            )}
                            {pathname !== '/home-battery/PowerOcean' && (
                                <li
                                    onClick={() => tabChange('Support')}
                                    className={`list-menu${idx == 'Support' || (idx == 'Support' && !hasDetail) ? ` active ${theme}` : ''}`}
                                >
                                    <span>{langKey === 'solarspeicher' ? ' FAQs' : t('product.nav_support')}</span>
                                </li>
                            )}
                            {pathname === '/home-battery/PowerOcean' && (
                                <li className="list-menu blog-link">
                                    <a target="_blank" rel="noreferrer" href={`https://homebattery.ecoflow.com/${locale}/software/EcoFlow-App`}>
                                        {t('product.nav_app')}
                                    </a>
                                </li>
                            )}
                        </ul>
                        {!IS_POWERSTREAM_COOPERATION &&
                            buyLink &&
                            ((productKey !== 'product_ps_river_river_256' || (productKey === 'product_ps_river_river_256' && buyLink)) &&
                            ((locale == 'sa' &&
                                [
                                    'river-mini-portable-power-station',
                                    'river-max-portable-power-station',
                                    'delta-mini-portable-power-station',
                                    'smart-home-panel',
                                ].includes(productKey)) ||
                                (['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale) && productKey === 'PowerStream')) ? (
                                ''
                            ) : (
                                <EfLink
                                    className="naver-buy-link"
                                    href={buyLink}
                                    // dataLayer={{
                                    //     event: 'uaEvent',
                                    //     event_name: 'buy',
                                    //     product_name: title,
                                    //     position: 'Product Detail',
                                    // }}
                                    onClick={() => handleBuyLinkClick(buyLink)}
                                >
                                    {t('product.buy')}
                                </EfLink>
                            ))}
                        {IS_POWERSTREAM_COOPERATION && (
                            <EfLink
                                className="naver-buy-link powerstream-cooperation"
                                href={`/${locale}/powerstream-cooperation#powerstream-cooperation-G`}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: title,
                                    position: 'Product Detail',
                                }}
                                onClick={() => {
                                    // 当前在 Specs/Support 时，#powerstream-cooperation-G 未渲染（只在 Overview 里），需先切回 Overview 再滚动
                                    if (idx !== 'Overview') {
                                        tabChange('Overview');
                                    }
                                }}
                            >
                                {t('product.partner')}
                            </EfLink>
                        )}
                        {productKey === 'product_ps_river_river_256' && !buyLink && locale !== 'tw' && (
                            <div className="buyBtn" onClick={onRiver2Buy}>
                                <span className="btn-link buy-btn">{buyText || t('product.buy')}</span>
                            </div>
                        )}
                        {showQuote && (
                            <EFButton
                                className="naver-quote-btn"
                                type="primary"
                                onClick={() => {
                                    if (langKey !== 'solarspeicher') {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'click_get_a_quote',
                                            product_name: title,
                                            position: 'Top_Nav',
                                            option_name: 'none',
                                        });
                                    }
                                    callbackQuote();
                                }}
                            >
                                {t('product.nav_quote')}
                            </EFButton>
                        )}
                        <div
                            className={`vertical-nav${isShowNav ? ' active' : ''}${
                                (t('product.buy') && buyLink) || (productKey === 'product_ps_river_river_256' && !buyLink && locale !== 'tw') ? '' : ' empty'
                            }`}
                        >
                            <ul>
                                <li className={idx == 'Overview' ? `active ${theme}` : ''} onClick={() => mTabChange('Overview')}>
                                    {langKey === 'solarspeicher' ? 'Solarspeicher' : t('product.nav_overview')}
                                </li>
                                {pathname === '/home-battery/PowerOcean' && title === 'PowerOcean' && (
                                    <li className="blog-link">
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.ecoflow.com/${locale}/solutions/home-battery/PowerOcean/EcoFlow-App`}
                                        >
                                            {t('product.nav_app')}
                                        </a>
                                    </li>
                                )}
                                {pathname !== '/home-battery/PowerOcean' && (
                                    <li className={idx == 'Specs' ? `active ${theme}` : ''} onClick={() => mTabChange('Specs')}>
                                        {langKey === 'solarspeicher' ? 'PowerOcean Serie' : t('product.nav_specs')}
                                    </li>
                                )}
                                {showBlog && (
                                    <li className="blog-link">
                                        <EfLink
                                            href="https://blog.ecoflow.com/de/category/heimspeicher/"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'product_navigation',
                                                navigation_name: 'Solar 101 (blog+user story)',
                                                product_name: title,
                                            }}
                                        >
                                            {t('product.nav_blog')}
                                        </EfLink>
                                    </li>
                                )}
                                <li className={idx == 'Support' ? `active ${theme}` : ''} onClick={() => mTabChange('Support')}>
                                    {langKey === 'solarspeicher' ? ' FAQs' : t('product.nav_support')}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {children}
        </section>
    );
}
